import React, { useState } from 'react';
import { MdOutlineMoreVert } from "react-icons/md";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { PackageFile } from "../typings";
import { FaGripLines } from "react-icons/fa6";
import EditableNumberInput from "../components/EditableNumberInput";

interface Props {
    content: PackageFile;
    onRemove: () => void;
}

function FileRow({ content, onRemove }: Props) {
    const [editable, setEditable] = useState(false);
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging
    } = useSortable({ id: content.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        zIndex: isDragging ? "100" : "auto",
        opacity: isDragging ? 0.3 : 1,
        display: 'flex',
        gap: '16px',
        flexDirection: 'row' as 'row'
    };

    return (
        <div className="box" style={style} ref={setNodeRef} >
            <FaGripLines size="32px" {...listeners} {...attributes} />
            <div className="card-title" style={{flex: 3}}>{content.name}</div>
            <div className="card-title" style={{flex: 1}}>
                <EditableNumberInput
                    editable={editable}
                    value={content.duration}
                    setValue={() => {}}
                    onClose={() => setEditable(false)}
                />
            </div>
            <div className="menu">
                <Menu>
                    <MenuButton className="menu-button"><MdOutlineMoreVert size="24px"/></MenuButton>
                    <MenuItems
                        className="menu-box"
                        anchor="bottom"
                    >
                        <MenuItem>
                            <div className="menu-item" onClick={() => setEditable(true)}>
                                Edit
                            </div>
                        </MenuItem>
                        <MenuItem>
                            <div className="menu-item" onClick={onRemove}>
                                Remove
                            </div>
                        </MenuItem>
                    </MenuItems>
                </Menu>
            </div>
        </div>
    );
}

export default FileRow;
